import { createFileRoute } from '@tanstack/react-router'

import { PlatformOrganizationAdvancedSettingsPage } from '../../../../components/pages/backoffice/platform/platform-organization-page/platform-organization-advanced-settings-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/$organizationTechnicalName/advanced-settings')({
  component: function Component() {
    const { organizationTechnicalName } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['organizationAdvanced.edit']}>
        <PlatformOrganizationAdvancedSettingsPage organizationTechnicalName={organizationTechnicalName} />
      </PermissionChecker>
    )
  },
})
